// extracted by mini-css-extract-plugin
export default {"viewLogin":"LoginView_viewLogin__hMfvO","viewLoginHeader":"LoginView_viewLoginHeader__1oVZz","appLogo":"LoginView_appLogo__ddcaa"};